"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IGS_NURTURING = exports.MARKETING_SALES = void 0;
var MARKETING_SALES = 'marketing-sales';
exports.MARKETING_SALES = MARKETING_SALES;
var IGS_NURTURING = 'igs-nurturing';
exports.IGS_NURTURING = IGS_NURTURING;